module.exports = __webpack_public_path__ + "static/media/6_Connect-Wires-to-Chime-Kit-3.6ddf2e50.svg";